import { render } from "./Experiment1.vue?vue&type=template&id=db2dfea4&scoped=true"
import script from "./Experiment1.vue?vue&type=script&lang=js"
export * from "./Experiment1.vue?vue&type=script&lang=js"

import "./Experiment1.vue?vue&type=style&index=0&id=db2dfea4&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2dfea4"]])

export default __exports__